/**
 * Skill Center 国际化配置
 */
import { i18n } from '@/i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

i18n.global.mergeLocaleMessage('cn', zhCN);
i18n.global.mergeLocaleMessage('en', enUS);
i18n.global.mergeLocaleMessage('tw', zhTW);
i18n.global.mergeLocaleMessage('jp', jaJP);
